import React from 'react';

function ConfirmByPassForm23({ onConfirm, enableEkycButton = false }) {
    return (
        <div
            className="p-8 fixed w-full z-[60] top-0 left-0 flex items-center justify-center h-full"
            style={{ backgroundColor: '#0000004d' }}
        >
            <div
                className="p-6 bg-white w-full rounded-md shadow-md text-gray"
                style={{ maxWidth: 414 }}
            >
                <p>閣下即將填寫以下資料：</p>

                <div className="pl-2 my-3">
                    <p>・工作資料</p>
                    <p>・居住資料</p>
                </div>

                <p className="text-justify">
                    提交完整資料可加快貸款審批速度，閣下亦可點擊「快速申請」，簡單輸入住址資料後即可提交貸款申請。
                </p>

                <div className="flex flex-col space-y-4 justify-center mt-9 px-10 mb-4">
                    <button
                        type="button"
                        onClick={() => onConfirm(true)}
                        className="rounded-full text-white text-xl py-4 bg-primary"
                    >
                        快速申請
                    </button>

                    {
                    enableEkycButton && 
                    <button
                        type="button"
                        onClick={() => onConfirm(false)}
                        className="rounded-full text-white text-xl py-4 bg-primary2"
                    >
                        提交完整資料
                    </button>
                    }
                </div>
            </div>
        </div>
    );
}

export default ConfirmByPassForm23;
